module["exports"] = [
  "##-#######",
  "+977-#-#######",
  "+977########"
];
